<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">
                {{ snackbar_msg }}
            </span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="mx-2 mt-2 elevation-2">
            <v-toolbar class="toolbar" flat dense color="white">
                <v-toolbar-title class="font-weight-bold">
                    Associate Template
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-row dense>
                    <v-col cols="12" sm="3">
                        <v-text-field dense outlined readonly label="Template"
                            v-model="headerData.template_name"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                        <v-text-field dense outlined readonly label="Academic Year" v-model="headerData.ay">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                        <v-text-field dense outlined readonly label="Standard" v-model="headerData.standard">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                        <v-text-field dense outlined readonly label="Credits" v-model="headerData.total_credits">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mx-2 mt-2 elevation-2">
            <v-toolbar flat dense color="white">
                <v-toolbar-title class="font-weight-bold">
                    Associate Template Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table :headers="headers" :items="associateTemplateList" class="elevation-1"
                :item-class="getBucketRowClass">
                <template v-slot:item.subject_or_group="{ item }">

                    <div class="chip-container">

                        <!-- SUBJECTS -->
                        <template v-if="
                            item.selection_type == 'Subject'
                            &&
                            item.linked_subject_list
                            &&
                            item.linked_subject_list.length > 0
                        ">

                            <v-tooltip bottom v-for="(sub, index) in item.linked_subject_list" :key="'sub' + index">

                                <template v-slot:activator="{ on, attrs }">

                                    <v-chip v-bind="attrs" v-on="on" small label class="subject-chip"
                                        @click="openLinkedSubject(sub, item)">
                                        <v-icon left x-small>
                                            mdi-book-open-variant
                                        </v-icon>

                                        <span class="chip-text">
                                            {{ sub.name }}
                                        </span>
                                    </v-chip>

                                </template>

                                <span>
                                    {{ sub.name }}
                                </span>

                            </v-tooltip>

                        </template>

                        <!-- GROUPS -->
                        <template v-if="
                            item.selection_type == 'Group'
                            &&
                            item.linked_group_list
                            &&
                            item.linked_group_list.length > 0
                        ">

                            <v-tooltip bottom v-for="(grp, index) in item.linked_group_list" :key="'grp' + index">

                                <template v-slot:activator="{ on, attrs }">

                                    <v-chip v-bind="attrs" v-on="on" small label class="group-chip"
                                        @click="openLinkedGroup(grp, item)">
                                        <v-icon left x-small>
                                            mdi-google-circles-communities
                                        </v-icon>

                                        <span class="chip-text">
                                            {{ grp.name }}
                                        </span>
                                    </v-chip>

                                </template>

                                <span>
                                    {{ grp.name }}
                                </span>

                            </v-tooltip>

                        </template>

                        <!-- ADD BUTTON -->

                        <v-btn v-if="showAddButton(item)" x-small rounded color="success" class="add-btn"
                            @click="openLinkDialog(item)">
                            <v-icon x-small>
                                mdi-plus
                            </v-icon>

                            Link
                        </v-btn>

                    </div>

                </template>
                <template v-slot:item.course_rule="{ item }">
                    <v-chip small dark label :color="item.course_rule == 'CP' ? 'pink lighten-2' : 'amber darken-2'"
                        class="font-weight-medium px-3">
                        {{ item.course_rule }}
                    </v-chip>
                </template>

                <template v-slot:item.selection_type="{ item }">

                    <v-chip small dark label :color="item.selection_type == 'Subject' ? 'indigo' : 'teal'"
                        class="font-weight-medium">
                        {{ item.selection_type }}
                    </v-chip>

                </template>
                <template v-slot:item.is_choice_based="{ item }">
                    <v-icon small :color="item.is_choice_based === true ? 'success' : 'error'">
                        {{
                            item.is_choice_based === true
                                ? 'mdi-check-circle-outline'
                                : 'mdi-close-circle-outline'
                        }}
                    </v-icon>
                </template>

                <template v-slot:item.is_optional="{ item }">
                    <v-icon small :color="item.is_optional === true ? 'success' : 'error'">
                        {{
                            item.is_optional === true
                                ? 'mdi-check-circle-outline'
                                : 'mdi-close-circle-outline'
                        }}
                    </v-icon>
                </template>

                <template v-slot:item.is_auto_allot="{ item }">
                    <v-icon small :color="item.is_auto_allot === true ? 'success' : 'error'">
                        {{
                            item.is_auto_allot === true
                                ? 'mdi-check-circle-outline'
                                : 'mdi-close-circle-outline'
                        }}
                    </v-icon>
                </template>

            </v-data-table>
        </v-card>

        <v-dialog v-model="linkDialog" width="1100" persistent>
            <v-card>
                <v-toolbar class="toolbar" dense flat>
                    <v-toolbar-title>
                        {{ dialogTitle }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="linkDialog = false">
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="mt-4">
                    <!-- SUBJECT + CP -->
                    <div v-if="dialogType == 'SUBJECT_CP'">
                        <v-row dense>
                            <v-col cols="12">

                                <v-autocomplete dense outlined return-object item-text="course_name" item-value="id"
                                    :items="subjectCpCourseList" label="Subject" v-model="subjectCpForm.course_data">
                                </v-autocomplete>

                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Fees" v-model="subjectCpForm.fees">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Capacity"
                                    v-model="subjectCpForm.capacity">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field dense outlined readonly filled label="Balance Student Count"
                                    v-model="subjectCpForm.balance_student" />
                            </v-col>
                            <!-- <v-col cols="12">
                                <v-switch inset label="Choice Based Subject" v-model="subjectCpForm.is_choice_based">
                                </v-switch>
                            </v-col> -->
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="linkDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" @click="saveSubjectCP">
                                Save
                            </v-btn>
                        </v-card-actions>
                        <!-- <v-data-table dense class="mt-4 elevation-1" :headers="subjectCpHeaders" :items="subjectCpList"
                            hide-default-footer>
                        </v-data-table> -->
                    </div>

                    <!-- SUBJECT + EL -->
                    <div v-if="dialogType == 'SUBJECT_EL'">
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete dense outlined return-object item-text="course_name" item-value="id"
                                    :items="subjectElCourseList" label="Subject" v-model="subjectElForm.course_data">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Fees" v-model="subjectElForm.fees">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Capacity"
                                    v-model="subjectElForm.capacity">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field dense outlined readonly filled label="Balance Student Count"
                                    v-model="subjectElForm.balance_student" />
                            </v-col>
                            <!-- <v-col cols="12">
                                <v-switch inset label="Choice Based Subject" v-model="subjectElForm.is_choice_based">
                                </v-switch>
                            </v-col> -->
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="linkDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" @click="saveSubjectEL">
                                Save
                            </v-btn>
                        </v-card-actions>
                        <!-- <v-data-table dense class="mt-4 elevation-1" :headers="subjectElHeaders" :items="subjectElList"
                            hide-default-footer>
                        </v-data-table> -->
                    </div>

                    <!-- GROUP + EL -->
                    <div v-if="dialogType == 'GROUP_EL'">
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete dense outlined return-object item-text="group_name" item-value="id"
                                    :items="groupElDropdownList" label="Subject Group" v-model="groupElForm.group_data">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Fees" v-model="groupElForm.fees">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Capacity"
                                    v-model="groupElForm.capacity">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field dense outlined readonly filled label="Balance Student Count"
                                    v-model="groupElForm.balance_student" />
                            </v-col>
                            <!-- <v-col cols="12">
                                <v-switch inset label="Choice Based Subject" v-model="groupElForm.is_choice_based">
                                </v-switch>
                            </v-col> -->
                        </v-row>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="linkDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" @click="saveGroupEL">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </div>

                    <!-- GROUP + CP -->
                    <div v-if="dialogType == 'GROUP_CP'">
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete dense outlined return-object item-text="group_name" item-value="id"
                                    :items="groupElDropdownList" label="Subject Group" v-model="groupCpForm.group_data">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Fees" v-model="groupCpForm.fees">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field dense outlined type="number" label="Capacity"
                                    v-model="groupCpForm.capacity">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field dense outlined readonly filled label="Balance Student Count"
                                    v-model="groupCpForm.balance_student" />
                            </v-col>

                            <!-- <v-col cols="12">
                                <v-switch inset label="Choice Based Subject" v-model="groupCpForm.is_choice_based">
                                </v-switch>
                            </v-col> -->

                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="linkDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" @click="saveGroupCP">
                                Save
                            </v-btn>
                        </v-card-actions>

                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios"
export default {
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            offering_id: this.$route.query.offering_id,
            headerData: {},
            associateTemplateList: [],
            linkDialog: false,
            dialogType: "",
            selectedItem: {},
            headers: [
                {
                    text: "Sr. No.",
                    value: "sr_no"
                },
                {
                    text: "Subject / Group",
                    value: "subject_or_group"
                },
                {
                    text: "Subject Head",
                    value: "subject_head"
                },
                {
                    text: "Selection Type",
                    value: "selection_type"
                },
                {
                    text: "Course Rule",
                    value: "course_rule"
                },
                {
                    text: "Credits",
                    value: "credits"
                },
                {
                    text: "Bucket Number",
                    value: "bucket_number"
                },
                {
                    text: "No Of Electives",
                    value: "no_of_electives"
                },
                {
                    text: "Elective Pickup Count",
                    value: "elective_pickup_count"
                },
                {
                    text: "Is Choice Based ?",
                    value: "is_choice_based"
                },
                {
                    text: "Is Optional ?",
                    value: "is_optional"
                },
                {
                    text: "Is Auto Allot ?",
                    value: "is_auto_allot"
                },
            ],

            subjectCpForm: {
                course_data: null,
                fees: null,
                capacity: null,
                balance_student: 0
                // is_choice_based: false
            },
            courseList: [],
            subjectCpCourseList: [],
            subjectElForm: {
                course_data: null,
                fees: null,
                capacity: null,
                balance_student: 0
            },
            subjectElCourseList: [],
            subjectElList: [],
            groupElForm: {
                group_data: null,
                fees: null,
                capacity: null,
                balance_student: 0
                // is_choice_based: false
            },
            groupCpForm: {
                group_data: null,
                fees: null,
                capacity: null,
                balance_student: 0
                // is_choice_based: false
            },
            groupElList: [],
            groupSubjectList: [],
            groupElHeaders: [
                {
                    text: "Sr No",
                    value: "sr_no"
                },
                {
                    text: "Group",
                    value: "group_name"
                },
                {
                    text: "Fees",
                    value: "fees"
                },
                {
                    text: "Capacity",
                    value: "capacity"
                },
                {
                    text: "Subjects",
                    value: "subjects",
                    sortable: false
                }
            ],
            groupSubjectHeaders: [
                {
                    text: "Course Code",
                    value: "course_code"
                },
                {
                    text: "Subject",
                    value: "course_name"
                }
            ],
            groupElDropdownList: [],
            isCpEdit: false,
            isElEdit: false,
            isGroupElEdit: false,
            isGroupCpEdit: false,
        }
    },

    mounted() {
        this.getAssociateTemplateHeader()
        this.getAssociateTemplateList()
    },
    computed: {
        dialogTitle() {
            if (this.dialogType == "SUBJECT_CP") {
                return "Link Subject"
            }

            else if (this.dialogType == "SUBJECT_EL") {
                return "Link Elective Subjects"
            }

            else if (this.dialogType == "GROUP_EL") {
                return "Link Elective Subject Groups"
            }

            else if (this.dialogType == "GROUP_CP") {
                return "Link Subject Group"
            }

            return "Associate Configuration"
        }
    },

    methods: {
        showAddButton(item) {
            // SUBJECT + CP

            if (
                item.selection_type == "Subject"
                &&
                item.course_rule == "CP"
            ) {

                let linkedCount =
                    item.linked_subject_list
                        ? item.linked_subject_list.length
                        : 0

                return linkedCount == 0
            }

            // SUBJECT + EL

            if (
                item.selection_type == "Subject"
                &&
                item.course_rule == "EL"
            ) {

                let linkedCount =
                    item.linked_subject_list
                        ? item.linked_subject_list.length
                        : 0

                return linkedCount < (item.no_of_electives || 0)
            }

            // GROUP + EL

            if (
                item.selection_type == "Group"
                &&
                item.course_rule == "EL"
            ) {

                let linkedCount =
                    item.linked_group_list
                        ? item.linked_group_list.length
                        : 0

                return linkedCount < (item.no_of_electives || 0)
            }

            // GROUP + CP

            if (
                item.selection_type == "Group"
                &&
                item.course_rule == "CP"
            ) {

                let linkedCount =
                    item.linked_group_list
                        ? item.linked_group_list.length
                        : 0

                return linkedCount == 0
            }

            return false
        },

        getBucketRowClass(item) {
            let colorMap = {
                1: "bucket-row-1",
                2: "bucket-row-2",
                3: "bucket-row-3",
                4: "bucket-row-4"
            }
            return colorMap[item.bucket_number] || ""
        },

        openLinkedSubject(sub, item) {
            this.selectedItem = item
            if (item.course_rule == "EL") {
                this.dialogType = "SUBJECT_EL"
                this.subjectElForm = {
                    id: sub.id,
                    course_data: {
                        id: sub.course_id,
                        course_name: sub.name
                    },
                    fees: sub.fees,
                    capacity: sub.capacity,
                    balance_student: sub.balance_student || 0
                    // is_choice_based: sub.is_choice_based
                }

                this.isElEdit = true
                this.getSubjectCourseDropdownList()
                this.linkDialog = true
            }

            else {

                this.dialogType = "SUBJECT_CP"
                this.subjectCpForm = {
                    id: sub.id,
                    course_data: {
                        id: sub.course_id,
                        course_name: sub.name
                    },
                    fees: sub.fees,
                    capacity: sub.capacity,
                    balance_student: sub.balance_student || 0
                    // is_choice_based: sub.is_choice_based
                }
                this.isCpEdit = true
                this.getSubjectCourseDropdownList()
                this.linkDialog = true
            }
        },
        getActionButton(item) {
            if (
                item.selection_type == "Subject"
                &&
                item.course_rule == "CP"
            ) {
                if (
                    item.linked_subject_list
                    &&
                    item.linked_subject_list.length > 0
                ) {
                    return {
                        text: "Manage",
                        color: "primary",
                        outlined: true
                    }
                }
                return {
                    text: "+ Link",
                    color: "success",
                    outlined: false
                }
            }
            if (
                item.selection_type == "Subject"
                &&
                item.course_rule == "EL"
            ) {
                let linkedCount =
                    item.linked_subject_list
                        ? item.linked_subject_list.length
                        : 0

                let totalCount =
                    item.no_of_electives || 0

                if (linkedCount >= totalCount) {

                    return {
                        text: "Manage",
                        color: "primary",
                        outlined: true
                    }
                }
                return {
                    text: "+ Add More",
                    color: "success",
                    outlined: false
                }
            }
            if (
                item.selection_type == "Group"
                &&
                item.course_rule == "EL"
            ) {
                return {
                    text: "+ Link",
                    color: "success",
                    outlined: false
                }
            }
            if (
                item.selection_type == "Group"
                &&
                item.course_rule == "CP"
            ) {
                return {
                    text: "Manage",
                    color: "primary",
                    outlined: true
                }
            }
            return {
                text: "+ Link",
                color: "success",
                outlined: false
            }
        },
        openLinkDialog(item) {
            this.selectedItem = item
            if (item.selection_type == "Subject" && item.course_rule == "CP") {
                this.dialogType = "SUBJECT_CP"
                this.getSubjectCPList(item.id)
                this.getSubjectCourseDropdownList()
                if (item.subject_or_group != "Not Linked") {
                    this.isCpEdit = true
                }
                else {
                    this.isCpEdit = false
                }
            }

            else if (item.selection_type == "Subject" && item.course_rule == "EL") {
                this.dialogType = "SUBJECT_EL"
                this.getSubjectCourseDropdownList()
                this.subjectElForm = {
                    course_data: null,
                    fees: null,
                    capacity: null,
                    balance_student: 0
                    // is_choice_based: false
                }
                this.isElEdit = false
            }

            else if (item.selection_type == "Group" && item.course_rule == "EL") {

                this.dialogType = "GROUP_EL"

                this.groupElForm = {
                    id: null,
                    group_data: null,
                    fees: null,
                    capacity: null,
                    balance_student: 0
                    // is_choice_based: false
                }

                this.isGroupElEdit = false

                this.getGroupELDropdownList(item.id)
                this.getGroupELList()

                this.linkDialog = true
            }

            else if (item.selection_type == "Group" && item.course_rule == "CP") {

                this.dialogType = "GROUP_CP"

                this.groupCpForm = {
                    id: null,
                    group_data: null,
                    fees: null,
                    capacity: null,
                    balance_student: 0
                    // is_choice_based: false
                }

                this.isGroupCpEdit = false

                this.getGroupELDropdownList(item.id)
            }
            this.linkDialog = true
        },

        openLinkedGroup(grp, item) {

            this.selectedItem = item

            if (item.course_rule == "CP") {

                this.dialogType = "GROUP_CP"

                this.groupCpForm = {
                    id: grp.id,
                    group_data: {
                        id: grp.group_id,
                        group_name: grp.name
                    },
                    fees: grp.fees,
                    capacity: grp.capacity,
                    balance_student: grp.balance_student || 0
                    // is_choice_based: grp.is_choice_based
                }

                this.isGroupCpEdit = true
            }

            else {

                this.dialogType = "GROUP_EL"

                this.groupElForm = {
                    id: grp.id,
                    group_data: {
                        id: grp.group_id,
                        group_name: grp.name
                    },
                    fees: grp.fees,
                    capacity: grp.capacity,
                    balance_student: grp.balance_student || 0
                    // is_choice_based: grp.is_choice_based
                }

                this.isGroupElEdit = true
            }

            this.getGroupELDropdownList(item.id)

            this.linkDialog = true
        },

        getGroupELDropdownList(template_details_id) {
            axios
                .post("/admission/getGroupELDropdownList", {
                    template_details_id: template_details_id,
                    template_offering_id: this.offering_id
                })
                .then((res) => {
                    if (res.data.code == "200") {
                        this.groupElDropdownList = res.data.groupList
                    }
                })
        },
        getGroupELList() {
            axios
                .post("/admission/getGroupELList", {
                    template_details_id: this.selectedItem.id
                })
                .then((res) => {
                    if (res.data.code == "200") {
                        this.groupElList = res.data.groupList
                    }
                })
        },
        saveGroupEL() {

            if (!this.groupElForm.group_data) {
                this.showSnackbar("error", "Please select Subject Group")
                return
            }

            if (
                this.groupElForm.fees == null ||
                this.groupElForm.capacity == null
            ) {
                this.showSnackbar("error", "Please enter both Fees and Capacity")
                return
            }

            let data = {
                id: this.groupElForm.id,
                template_details_id: this.selectedItem.id,
                template_offering_id: this.offering_id,
                group_id: this.groupElForm.group_data.id,
                fees: this.groupElForm.fees,
                capacity: this.groupElForm.capacity,
                // is_choice_based: this.groupElForm.is_choice_based
            }

            axios
                .post("/admission/saveGroupEL", data)

                .then((res) => {

                    if (res.data.flag == "YES") {

                        this.showSnackbar("success", res.data.msg)

                        this.groupElForm = {
                            group_data: null,
                            fees: null,
                            capacity: null,
                            // is_choice_based: false
                        }

                        this.getGroupELList()
                        this.getAssociateTemplateList()
                        this.linkDialog = false;
                    }

                    else {

                        this.showSnackbar("error", res.data.msg)
                    }
                })
        },

        saveGroupCP() {

            if (!this.groupCpForm.group_data) {
                this.showSnackbar("error", "Please select Subject Group")
                return
            }

            if (
                this.groupCpForm.capacity == null ||
                this.groupCpForm.fees == null
            ) {
                this.showSnackbar("error", "Please enter both Fees and Capacity")
                return
            }

            let data = {

                template_details_id: this.selectedItem.id,
                template_offering_id: this.offering_id,
                group_id: this.groupCpForm.group_data.id,
                fees: this.groupCpForm.fees,
                capacity: this.groupCpForm.capacity,
                // is_choice_based: this.groupCpForm.is_choice_based
            }

            axios
                .post("/admission/saveGroupCP", data)

                .then((res) => {

                    if (res.data.flag == "YES") {

                        this.showSnackbar("success", res.data.msg)

                        this.groupCpForm = {
                            group_data: null,
                            fees: null,
                            capacity: null,
                            // is_choice_based: false
                        }

                        this.getAssociateTemplateList()

                        this.linkDialog = false
                    }

                    else {

                        this.showSnackbar("error", res.data.msg)
                    }
                })
        },

        getSubjectCPList(template_details_id) {
            axios
                .post("/admission/getSubjectCPList", {
                    template_details_id: template_details_id,
                    template_offering_id: this.offering_id
                })

                .then((res) => {
                    if (res.data.code == "200") {
                        let data = res.data.data
                        if (data && data.id) {
                            this.subjectCpForm = {
                                course_data: {
                                    id: data.course_id,
                                    course_name: data.course_name
                                },
                                fees: data.fees,
                                capacity: data.capacity,
                                balance_student: data.balance_student || 0
                                // is_choice_based: data.is_choice_based
                            }
                            this.isCpEdit = true
                        }
                        else {
                            this.subjectCpForm = {
                                course_data: null,
                                fees: null,
                                capacity: null,
                                balance_student: 0
                                // is_choice_based: false
                            }
                            this.isCpEdit = false
                        }
                    }
                })
        },
        getSubjectCourseDropdownList() {
            axios
                .post("/admission/getSubjectCourseDropdownList", {

                    template_offering_id: this.offering_id
                })

                .then((res) => {
                    if (res.data.code == "200") {
                        this.subjectCpCourseList = res.data.courseList
                        this.subjectElCourseList = res.data.courseList
                    }
                })
        },
        saveSubjectEL() {
            if (
                this.subjectElForm.capacity == null ||
                this.subjectElForm.fees == null
            ) {
                this.showSnackbar("error", "Please enter both Fees and Capacity")
                return
            }

            let data = {
                id: this.subjectElForm.id,
                template_details_id: this.selectedItem.id,
                template_offering_id: this.offering_id,
                course_id: this.subjectElForm.course_data.id,
                fees: this.subjectElForm.fees,
                capacity: this.subjectElForm.capacity,
                // is_choice_based: this.subjectElForm.is_choice_based
            }

            axios
                .post("/admission/saveSubjectEL", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.subjectElForm = {
                            course_data: null,
                            fees: null,
                            capacity: null
                        }
                        this.showSnackbar("success", res.data.msg)
                        this.linkDialog = false
                        this.getAssociateTemplateList()
                    } else {
                        this.showSnackbar("error", res.data.msg)
                        // this.linkDialog = false
                    }
                })
        },
        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        },

        saveSubjectCP() {
            if (
                this.subjectCpForm.capacity == null ||
                this.subjectCpForm.fees == null
            ) {
                this.showSnackbar("error", "Please enter both Fees and Capacity")
                return
            }

            let data = {
                template_details_id: this.selectedItem.id,
                template_offering_id: this.offering_id,
                fees: this.subjectCpForm.fees,
                capacity: this.subjectCpForm.capacity,
                course_head_id: this.selectedItem.course_head_id,
                course_id: this.subjectCpForm.course_data.id,
                // is_choice_based: this.subjectCpForm.is_choice_based
            }

            axios
                .post("/admission/saveSubjectCP", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.subjectCpForm = {
                            fees: null,
                            capacity: null
                        }
                        this.showSnackbar("success", res.data.msg)
                        this.linkDialog = false
                        this.getAssociateTemplateList()
                    } else {
                        this.showSnackbar("error", res.data.msg)
                        // this.linkDialog = false
                    }
                })
        },

        getAssociateTemplateHeader() {
            this.overlay = true;
            axios
                .post("/admission/getAssociateTemplateHeader", {
                    offering_id: this.offering_id
                })

                .then((res) => {

                    if (res.data.code == "200") {
                        this.headerData = res.data.data
                        this.overlay = false;
                    }
                })
        },
        getAssociateTemplateList() {
            axios
                .post("/admission/getAssociateTemplateList", {
                    offering_id: this.offering_id
                })

                .then((res) => {
                    if (res.data.code == "200") {
                        this.associateTemplateList = res.data.associateTemplateList
                    }
                })
        }
    }
}
</script>
<style scoped>
.v-data-table {
    border-radius: 4px;
}

.bucket-row-1 {
    border-left: 5px solid #fbc02d;
}

.bucket-row-2 {
    border-left: 5px solid #43a047;
}

.bucket-row-3 {
    border-left: 5px solid #1e88e5;
}

.bucket-row-4 {
    border-left: 5px solid #8e24aa;
}

.chip-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-width: 340px;
}

.subject-chip {
    background: #eef2ff !important;
    border: 1px solid #c7d2fe;
    color: #3730a3 !important;
    cursor: pointer;
    transition: 0.2s;
    max-width: 170px;
}

.subject-chip:hover {
    background: #dbeafe !important;
    transform: translateY(-1px);
}

.group-chip {
    background: #ecfeff !important;
    border: 1px solid #a5f3fc;
    color: #0f766e !important;
    cursor: pointer;
    transition: 0.2s;
    max-width: 170px;
}

.group-chip:hover {
    background: #cffafe !important;
    transform: translateY(-1px);
}

.chip-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 120px;
}

.add-btn {
    height: 26px !important;
    font-weight: 600;
}
</style>